var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSicoob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104.1 104.1",
    style: {
      enableBackground: "new 0 0 104.1 104.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.stst0{fill:#8CC63F;}\n\t.stst1{fill:#0DA292;}\n\t.stst2{fill:#C9DA2B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "stst0",
    d: "M14.9,15.7c-0.6,0.1-1.3,0.2-1.9,0.6c-1.4,0.8-2.2,2.3-2.2,3.9c0,0.7,0.1,1.4,0.5,2l22,38.2l7.1-12.3L52,28.1 l-7.1-12.3H14.9L14.9,15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stst1",
    d: "M44.9,15.7l18.7,32.4h13.2h1.1l15-26c0.3-0.6,0.4-1.2,0.4-1.9c0-2.4-1.9-4.3-4.2-4.5H44.9L44.9,15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stst2",
    d: "M76.8,48.1H40.4l-7.1,12.3l15.1,25.9c0.4,0.5,0.8,1,1.4,1.4c0.7,0.4,1.5,0.6,2.2,0.6c1.5,0,2.9-0.7,3.7-2 l22.1-38.2H76.8L76.8,48.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSicoob);
export default __webpack_public_path__ + "static/media/sicoob.f2d5ae719401aa7ab26787bf4cbd5a9b.svg";
export { ForwardRef as ReactComponent };